const suppliers = {
  toast: {
    error: {
      badResponse: '[Supplier] resposta inválida do servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Supplier] foi criado com sucesso',
      },
      edit: {},
    },
  },
  createNew: 'Criar',
  updateRanking: 'Atualizar Classificação',
  table: {
    headers: {
      name: 'Nome',
      supplierStatus: 'Status',
      rank: 'Classificação',
      tier: 'Nível',
      overallScore: 'Pontuação Geral',
      onTimePerformance: 'Desempenho Pontual',
      noShowRate: 'Taxa de Não Comparecimento',
      cancellationsRate: 'Taxa de Cancelamentos',
      acceptanceRate: 'Taxa de Aceitação',
      avgResponseTime: 'Tempo Médio de Resposta',
      vehicles: 'Veículos',
      complaints: 'Reclamações',
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission require',
    },
  },

  create: {
    successToast: {
      message: 'Sucesso! Fornecedor criado!',
    },
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível criar fornecedor',
    },
  },

  edit: {
    successToast: {
      message: 'Sucesso! Fornecedor atualizado!',
    },
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível atualizar o fornecedor',
    },
  },

  deleteModal: {
    header: 'Excluir fornecedores',
    body: 'Você está prestes a excluir {{num}} fornecedores.',
  },

  deleteToast: 'Não é possível excluir fornecedores',

  forms: {
    header: {
      createSupplier: {
        title: 'Criar',
      },

      updateSupplier: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      rank: {
        header: 'Classificação do fornecedor',
        fields: {
          rank: 'Classificação {{rank}}',
          score: 'Nota: ',
        },
      },
      generalInformation: {
        header: 'Informações Gerais',
        fields: {
          name: 'Nome',
          status: 'Status',
          tier: 'Nível',
          tierAndScore: 'Nível e Pontuação do Fornecedor',
          statusOptions: {
            select: 'Selecione',
            active: 'Ativo',
            inactive: 'Inativa',
          },
        },
      },
      supplierKpis: {
        header: 'KPIs do fornecedor',
        fields: {
          onTimePerformance: 'Desempenho no prazo (%)',
          noShowRate: 'Taxa de não comparecimento (%)',
          cancellationsRate: 'Taxa de cancelamentos (%)',
          acceptanceRate: 'Taxa de aceitação (%)',
          avgResponseTime: 'Tempo médio de resposta (min)',
          complaints: 'Reclamações',
        },
      },
      advancedSettings: {
        header: 'Configurações avançadas',
        fields: {
          areas: 'Zonas',
          attributes: 'Atributos',
          excludedAttributes: 'Atributos excluídos',
          minTrips: 'Viagens mínimas',
          maxTrips: 'Viagens máximas',
          allowDecline: 'Permitir recusar',
          allowSharedRides: 'Permitir Viajes Compartidos',
          weekDays: 'Disponibilidade durante a semana',
        },
      },
      contactInformation: {
        header: 'Informações de contato',
        fields: {
          name: 'Nome',
          type: 'Tipo',
          phone: 'Telefone',
          email: 'E-mail',
          address: 'Endereço',
          comment: 'Comentário',
          btnAddContact: 'Adicionar contato',
        },
      },
      notes: {
        header: 'Notas',
        fields: {
          notes: 'Notas',
        },
      },
      vehiclesTable: {
        cells: {
          name: 'Nome',
          seats: 'Assentos',
          attributes: 'Atributos',
        },
      },
    },
    select: 'Selecione',
  },
  delete: {
    confirmation: {
      header: 'Confirmação de exclusão de fornecedor',
      body: 'Os fornecedores foram excluídos com sucesso',
    },
  },
};

export default suppliers;
